const getStaffList = () => {
    const staffList = localStorage.getItem("staffList")
        ? JSON.parse(localStorage.getItem("staffList"))
        : null;

    if (staffList) return staffList;

    return null;
};

const InitialState = {
    staffList: getStaffList(),
};

const StaffListReducer = (state = InitialState, action) => {
    if (action.type === "Save_StaffList") {
        const newState = {
            staffList: action.payload,
        };

        localStorage.setItem("staffList", JSON.stringify(action.payload));

        return newState;
    }

    //logout
    else if (action.type === "Remove_User") {
        const newState = {
            staffList: null,
        };

        localStorage.removeItem("staffList");
        return newState;
    }

    return state;
};

export default StaffListReducer;
